import { render, staticRenderFns } from "./NotificationCardAuthor.vue?vue&type=template&id=94da8770&scoped=true"
import script from "./NotificationCardAuthor.vue?vue&type=script&lang=js"
export * from "./NotificationCardAuthor.vue?vue&type=script&lang=js"
import style0 from "./NotificationCardAuthor.vue?vue&type=style&index=0&id=94da8770&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94da8770",
  null
  
)

export default component.exports